import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AgreementsDateBaseDirective } from '../agreements.base';

@Component({
  selector: 'td-wb-td-agreement',
  templateUrl: './td-agreement.component.html',
  styleUrls: ['../agreements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TdAgreementComponent extends AgreementsDateBaseDirective {
  @Input() disabled: boolean;
}
